import imageCompression from 'browser-image-compression';
import { supabase } from '../lib/supabase';
import { WebsiteMediaEntry, WebsiteMediaPlacementKey } from '@pigeons/shared-website-media';
import { websiteMediaRepository } from '../repositories/websiteMediaRepository';

const WEBSITE_MEDIA_PREFIX = 'website-images';

const get_file_extension = (fileName: string): string => {
  const extension = fileName.split('.').pop()?.toLowerCase();
  return extension || 'jpg';
};

export const websiteMediaService = {
  async listWebsiteMedia(): Promise<WebsiteMediaEntry[]> {
    return websiteMediaRepository.listEntries();
  },

  async uploadWebsiteMediaImage(
    placementKey: WebsiteMediaPlacementKey,
    file: File
  ): Promise<string> {
    const compressedFile = await imageCompression(file, {
      maxSizeMB: 1,
      maxWidthOrHeight: 1800,
      useWebWorker: true,
      initialQuality: 0.82,
    });

    const fileExtension = get_file_extension(file.name);
    const fileName = `${Date.now()}-${Math.random().toString(36).slice(2)}.${fileExtension}`;
    const filePath = `${WEBSITE_MEDIA_PREFIX}/${placementKey}/${fileName}`;

    const { error: uploadError } = await supabase.storage
      .from('website_media')
      .upload(filePath, compressedFile, {
        upsert: false,
      });

    if (uploadError) {
      throw uploadError;
    }

    const { data } = supabase.storage.from('website_media').getPublicUrl(filePath);
    return data.publicUrl;
  },

  async updateWebsiteMediaEntry(params: {
    placementKey: WebsiteMediaPlacementKey;
    imageUrl?: string | null;
    altTextFr?: string | null;
    altTextEn?: string | null;
  }): Promise<WebsiteMediaEntry> {
    return websiteMediaRepository.upsertEntry({
      placement_key: params.placementKey,
      image_url: params.imageUrl ?? null,
      alt_text_fr: params.altTextFr ?? null,
      alt_text_en: params.altTextEn ?? null,
    });
  },

  async clearWebsiteMediaEntry(placementKey: WebsiteMediaPlacementKey): Promise<void> {
    await websiteMediaRepository.deleteEntry(placementKey);
  },
};
